export default __webpack_public_path__ + "static/summer_containers1-fd971d72173a65cd144b3c3d52df6920.webp";